import { IconButton as IconButtonRoot, Link } from '@xprog/prensa'
import { IconButtonProps as IconButtonRootProps } from '@xprog/prensa/types'
import React from 'react'

import Icon from '../../components/Icon/Icon.index'

export interface IconButtonProps extends IconButtonRootProps {
  icon: any;
  href?: string;
  linkProps?: any;
}

const IconButton: React.FC<IconButtonProps> = ({ href, icon, linkProps, ...otherProps }) => {
  return (
    <IconButtonRoot
      variant='ghost'
      size='sm'
      icon={
        <Link
          bypass={!href}
          href={href || ''}
          {...linkProps}
        >
          <Icon {...icon} />
        </Link>
      }
      {...otherProps}
    />
  )
}

export default IconButton
